import { getProfiles, getSelectedProfileId } from '../state-manager.js';
import { hydrateFeeds } from './ui-feeds.js';
import { hydrateSlider } from './ui-slider.js';
import { initProfileNavigator } from './ui-selector.js';
import { getClientFoods } from './ui-foods.js';

// This function shows the main content of the app
export async function showMainContent() {
  console.log('[Main] Showing app content...');

  const appContent = document.getElementById('app-content');
  if (appContent) {
    appContent.classList.remove('hidden');
  }

  const profiles = getProfiles();
  // If no profile is selected, we can't fetch feeds
  if (!profiles || profiles.length === 0) {
    console.warn('No profiles exist, cannot fetch feeds.');
    return;
  }

  let profileId = getSelectedProfileId();
  if (!profileId) {
    console.log('[Main] No profile selected.');
    profileId = profiles[0].id; // Default to the first profile if none is selected
  }
  console.log(`[Main] Set default [0] profile ID: ${profileId}`);
  // Optional: hydrate individual panels here
  // Load all foods for the client - hydration from the state manager
  await getClientFoods();
  // hydrateFeeds(profileId);
  hydrateSlider(profileId);
  initProfileNavigator(profiles);
  // Update the date and time in the header
  updateDateTime(); // Initial call to set the date and time
  setInterval(updateDateTime, 60000); // Update every minute
}

// Function to update the date and time
function updateDateTime() {
  const today = new Date();
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // Use 24-hour format
  };
  dateTitle.textContent = today.toLocaleDateString(undefined, options);
}
